import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "app-product-option",
    templateUrl: "./product-option.component.html",
    styleUrls: ["./product-option.component.sass"]
})
export class ProductOptionComponent implements OnInit {
    @Input() Options: any =[]
    extraPrice = 0;
    @Output() optionSelected: EventEmitter<any> = new EventEmitter();

    selectedName = [];
    totalPrice = 0;
    radioValue = 0;
    selectedItems = [];

    constructor() {
      //  this.Options = 
    }



    ngOnInit() {

        this.Options = [
            [
                {
                    id: 11,
                    isonprice: false,
                    price: 2.0,
                    value: "Normal",
                    attribute: "Deep Pan",
                    attributegroup: "Pizza Base",
                    type: "radio",
                    selected: true
                },
                {
                    id: 12,
                    isonprice: true,
                    price: 3.0,
                    value: "Normal",
                    attribute: "Thin Crust",
                    attributegroup: "Pizza Base",
                    type: "radio",
                    selected: false
                },
                {
                    id: 13,
                    isonprice: false,
                    price: 4.0,
                    value: "Normal",
                    attribute: "Stuffed Crust",
                    attributegroup: "Pizza Base",
                    type: "radio",
                    selected: false
                }
            ],
            [
                {
                    id: 14,
                    isonprice: false,
                    price: 4.0,
                    value: "Normal",
                    attribute: "Deep Pan",
                    attributegroup: "Meal Options",
                    type: "checkbox",
                    selected: false
                },
                {
                    id: 15,
                    isonprice: true,
                    price: 6.0,
                    value: "Normal",
                    attribute: "Thin Crust",
                    attributegroup: "Meal Options",
                    type: "checkbox",
                    selected: false
                },
                {
                    id: 16,
                    isonprice: true,
                    price: 2.0,
                    value: "Normal",
                    attribute: "Stuffed Crust",
                    attributegroup: "Meal Options",
                    type: "checkbox",
                    selected: true
                }
            ],
            [
                {
                    id: 17,
                    isonprice: false,
                    price: 0.0,
                    value: "Normal",
                    attribute: "Deep Pan",
                    attributegroup: "Pizza Base2",
                    type: "radio",
                    selected: false
                },
                {
                    id: 18,
                    isonprice: false,
                    price: 0.0,
                    value: "Normal",
                    attribute: "Thin Crust",
                    attributegroup: "Pizza Base2",
                    type: "radio",
                    selected: false
                },
                {
                    id: 19,
                    isonprice: true,
                    price: 4.0,
                    value: "Normal",
                    attribute: "Stuffed Crust",
                    attributegroup: "Pizza Base2",
                    type: "radio",
                    selected: true
                }
            ]
        ];
      
    }

    getPrice(event, price, isonprice) {
        const target = event.target;

        if (!isonprice) {
            return;
        }

        let selectedIndex = this.selectedItems.findIndex(
            item => item.name == target.name
        );

        if (target.type == typeEnum.radio) {
            if (selectedIndex > -1) {
                this.extraPrice -= this.selectedItems[selectedIndex].price;
                this.selectedItems.splice(selectedIndex, 1);

                this.selectedItems.push({
                    id: target.id,
                    type: target.type,
                    name: target.name,
                    price: price
                });
                this.extraPrice += price;
            } else {
                this.selectedItems.push({
                    id: target.id,
                    type: target.type,
                    name: target.name,
                    price: price
                });
                this.extraPrice += price;
            }
        } else {
            if (target.checked) {
                this.extraPrice += price;
                this.selectedItems.push({
                    id: target.id,
                    type: target.type,
                    name: target.name,
                    price: price
                });
            } else {
                this.extraPrice -= price;
                this.selectedItems.splice(selectedIndex, 1);
            }
        }

        let model = {
            selectedItems: this.selectedItems,
            totalPrice: this.extraPrice
        };

        this.optionSelected.emit(model);
    }
}

export enum typeEnum {
    radio = "radio",
    checkbox = "checkbox"
}
